<template>
    <div :style="styleDynamicElement(el)" :class="el.getAnimationClass(currentElementIndex)"
        @mousedown="eventDrag($event, el.previewId)">
        <div class="text-media" :style="el.getStyle(currentElementIndex)">
            <p>{{ el.Text }}</p>
        </div>
    </div>
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
export default {
    name: 'TextMedia',
    extends: BasePreviewComponents,
    methods: {
    }
}
</script>

<style scoped>
.text-media > p {
    pointer-events: none;
      -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

.text-media {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
</style>


